module.exports = __webpack_public_path__ + "img/txt.5f5535e4.svg";